import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import CommonService from "../../services/CommonService";

export const fetchCategories = createAsyncThunk(
  "common/fetchCategories",
  async () => {
    try {
      const res = await CommonService.getCategories();
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchUserCategories = createAsyncThunk(
  "common/fetchUserCategories",
  async (id) => {
    try {
      const res = await CommonService.getUserCategories(id);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchUserRelatedCategories = createAsyncThunk(
  "common/fetchUserRelatedCategories",
  async (data) => {
    try {
      const res = await CommonService.getUserRelatedCategories(data);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchCountries = createAsyncThunk(
  "common/fetchCountries",
  async () => {
    try {
      const res = await CommonService.getCountries();
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchCities = createAsyncThunk(
  "common/fetchCities",
  async (data) => {
    try {
      const res = await CommonService.getCities(data);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchHomePage = createAsyncThunk(
  "common/fetchHomePage",
  async () => {
    try {
      const res = await CommonService.getHomePageData();
      return res.data[0];
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchDistricts = createAsyncThunk(
  "common/fetchDistricts",
  async () => {
    try {
      const res = await CommonService.getDistrict();
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchSubCategories = createAsyncThunk(
  "common/fetchSubCategories",
  async (id) => {
    try {
      const res = await CommonService.getSubCategories(id);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchPrivacyPolicy = createAsyncThunk(
  "common/fetchPrivacyPolicy",
  async () => {
    try {
      const res = await CommonService.getPrivacyPolicy();
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchTermsCondition = createAsyncThunk(
  "common/fetchTermsCondition",
  async () => {
    try {
      const res = await CommonService.getTermsCondition();
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

export const CreateAdditionalDetailSave = createAsyncThunk(
  "common/CreateAdditionalDetailSave",
  async (data) => {
    try {
      const res = await CommonService.additionalDetailSave(data);
      return res;
    } catch (error) {
      console.log(error);
    }
  }
);

export const fetchSystemConfiguration = createAsyncThunk(
  "common/fetchSystemConfiguration",
  async () => {
    try {
      const res = await CommonService.getSystemConfiguration();
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
);

const initialState = {
  loading: false,
  error: "",
  categories: [],
  userCategories: [],
  userRelatedCategories: [],
  cities: [],
  countries: [],
  homePage: null,
  districts: [],
  subCategories: [],
  privacyPolicy: null,
  termsCondition: null,
  systemConfiguration: null,
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {},
  extraReducers(builder) {
    //Get CATEGORIES
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategories.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.categories = payload;
      })
      .addCase(fetchCategories.rejected, (state) => {
        state.loading = false;
      });

      builder
      .addCase(fetchUserCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserCategories.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.userCategories = payload;
      })
      .addCase(fetchUserCategories.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(fetchUserRelatedCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserRelatedCategories.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.userRelatedCategories = payload;
      })
      .addCase(fetchUserRelatedCategories.rejected, (state) => {
        state.loading = false;
      });

    //Get COUNTRIES
    builder
      .addCase(fetchCountries.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCountries.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.countries = payload;
      })
      .addCase(fetchCountries.rejected, (state) => {
        state.loading = false;
      });

    //Get CITIES
    builder
      .addCase(fetchCities.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCities.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.cities = payload;
      })
      .addCase(fetchCities.rejected, (state) => {
        state.loading = false;
      });

    //Get CITIES
    builder
      .addCase(fetchHomePage.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchHomePage.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.homePage = payload;
      })
      .addCase(fetchHomePage.rejected, (state) => {
        state.loading = false;
      });

    // get Districts

    builder
      .addCase(fetchDistricts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDistricts.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.districts = payload;
      })
      .addCase(fetchDistricts.rejected, (state) => {
        state.loading = false;
      });

    //GET SUB CATEGORIES
    builder
      .addCase(fetchSubCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSubCategories.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.subCategories = payload;
      })
      .addCase(fetchSubCategories.rejected, (state) => {
        state.loading = false;
      });

    //GET PRIVACY POLICY
    builder
      .addCase(fetchPrivacyPolicy.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPrivacyPolicy.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.privacyPolicy = payload;
      })
      .addCase(fetchPrivacyPolicy.rejected, (state) => {
        state.loading = false;
      });
    //GET Terms Condition
    builder
      .addCase(fetchTermsCondition.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTermsCondition.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.termsCondition = payload;
      })
      .addCase(fetchTermsCondition.rejected, (state) => {
        state.loading = false;
      });
      builder
      .addCase(fetchSystemConfiguration.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSystemConfiguration.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.systemConfiguration = payload;
        console.log("systemConfiguration in login is:", state.systemConfiguration);
      })
      .addCase(fetchSystemConfiguration.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default commonSlice.reducer;
